import useIsMobile from '@/hooks/useIsMobile';
import ProductCollectionDesktop from './desktop';
import ProductCollectionMobile from './mobile';
import useProductCollection from './useProductCollection';

const ProductCollection = () => {
  const isMobile = useIsMobile(992);
  const viewModel = useProductCollection();

  if (isMobile) {
    return <ProductCollectionMobile viewModel={viewModel} />;
  }

  return <ProductCollectionDesktop viewModel={viewModel} />;
};

export default ProductCollection;